<!--
- Office Hours
-- use this page to check various conditions and route to different areas of the SPA
-- https://docs.google.com/document/d/1q0BSVoD2ouldv6l59L3SpleIHA7d66QKmCMKYEJz_2E/edit?tab=t.0#heading=h.jutogjydxz2b
-->

<template>
	<nav-tab-content>
		
		<h2>
			<router-link 
			:to="{
				name: 'AccountBilling'
			}"
			class="hover-underline">
			&lt; Back to your Account Settings</router-link>
		</h2>

		<div v-if="!hasLoaded">
			<h3 class="text-center">Checking Zoom status...</h3><br />
		</div>
		<div v-else-if="!hasPrioritySupport" key="divNoPrioritySupport">
			<h3 class="text-center">Oops! It looks like you don't have Priority Support.</h3><br />
			<div class="row">
				<div class="col-6 org-size">
					<p><strong>Priority Support</strong>&nbsp;gives you faster responses and exclusive access to our live&nbsp;<strong>Office Hours Webinar</strong>&nbsp;&mdash; all for just&nbsp;<strong>$19.95/year</strong>.</p>
					<p>Here&rsquo;s what you get:</p>
					<p>
						✨&nbsp;<strong>Zoom to the front of the line.</strong>&nbsp;When you reach out to our Support Team, your question sparkles its way to the top. No waiting in line behind mortals.<br />
					</p>
					<p>
						🎤&nbsp;<strong>Join live Office Hours.</strong>&nbsp;Every Friday at 8pm Eastern, our Support team host a live Zoom session just for Priority Support members. Ask anything &mdash; APA, MLA, Turabian, or just &ldquo;how do I write this without crying?&rdquo; &mdash; and get real-time answers on the spot.
					</p>
					<div class="row">
						<div class="col">
							<div class="d-grid">
								<button 
									class="btn btn-success"
									type="button"
									@click.prevent="btnAddPrioritySupport">
									Add Priority Support to my Account
								</button>
							</div>
						</div>
					</div>
				</div><!--col-->
				<div class="col-6">
					<div class="ratio ratio-16x9">
						<iframe src="https://www.youtube.com/embed/ZRvA2Ah1y14" frameborder="0" allowfullscreen title="YouTube Video Explaining Priority Support" />
					</div>
				</div><!--col-->
			</div><!--row-->
		</div>

		<div v-else-if="!isDayCheck && !isTimeCheck" key="divNotTimeYet" class="pt-2">
			<h3 class="text-center">Hold your highlighters — you're a little early 🦄⏰</h3><br />
			<div class="row">
				<div class="col-6 org-size">
					<p>Office Hours kicks off&nbsp;<strong>every&nbsp;</strong><strong>Friday at 8pm ET</strong>, and you&#39;re ahead of the game.</p>
					<p  v-if="isShowJoinButtonMessage">A button to join the Office Hours webinar will appear below when it&#39;s showtime.</p>
					<p>Until then, you don&#39;t have to wait to get your burning questions answered! Our Support Team is standing by to answer your questions every day until 11pm ET.</p>
					<!-- <p>You can also watch a recent Getting Started webinar to the right while you wait.</p> -->

					<div class="row">
						<div class="col">
							<div class="d-grid gap-2">
								<router-link :to="{name:'ContactSupport'}" class="btn btn-primary">
									Don't wait - contact our Support Team
								</router-link>

								<a :href="linkToZoomCall" class="btn btn-success" v-if="isJoinButtonShown">
									Join the Office Hours Webinar
								</a>
								<a href="https://perrla.myflodesk.com/officehoursreminder" class="btn btn-outline-success" v-else>
									Sign up for a reminder this Friday
								</a>
							</div>
						</div>
					</div>
				</div><!--col-->
				<div class="col-6">
					<div class="ratio ratio-16x9">
						<iframe src="https://www.youtube.com/embed/NgowrhO7z_E" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen title="Getting Your Head Around APA" />
					</div>
				</div><!--col-->
			</div><!--row-->
		</div>
		<div v-else>
			<h3 class="text-center">Join the Office Hours Webinar</h3><br />
			<div class="row">
				<div class="col">
					<div class="d-grid">
						<a :href="linkToZoomCall" class="btn btn-success">
							Join the Office Hours Webinar
						</a>
					</div>
				</div>
			</div>
		</div>
		
		<!--
		<p>Has Priority Support: {{ hasPrioritySupport }}</p>
		<p>Is Friday: {{ isDayCheck }}</p>
		<p>Is Time: {{ isTimeCheck }}</p> -->

	</nav-tab-content>
</template>

<script>
import AS_SyncData from '@/services/app/syncData';
import config from '@/config';
import NavTabContent from '@/components/NavTabContent';

const ACTIVE_DAY_OF_WEEK = 5; // 5 - Friday
const ACTIVE_TIME_START = { hour: 23, minute: 45};	//7:45p EST = 23:45 UTC (4 hour offset from EST)
const ACTIVE_TIME_END = { hour: 25, minute: 0 };	//9:00p EST = 25:00 UTC (4 hour offset from EST)
const MINS_BEFORE_TO_START_TIMER = 15;
const LINK_TO_ZOOM_CALL = 'https://zoom.us/j/96401106958?pwd=hP0AaR81rHEZ1cbTrpyPdKQwGIsFgK.1';
const SECONDS_THE_TIMER_RUNS = 30;

export default {
	name: 'OfficeHours',
	data() {
		return {
			hasLoaded: false,
			hasPrioritySupport: false,
			isDayCheck: false,	// must be on Friday (5)
			isJoinButtonShown: false,	// Bool that shows the the Join button or not (keep in mind another flag enables the button)
			isTimeCheck: false,	// between 7:45pm - 9pm Eastern (11:45 pm GMT)
			isShowJoinButtonMessage: false,	 // boolean to show the p tag info that a button will appear (this is for when there is a timer actie)
			linkToZoomCall: LINK_TO_ZOOM_CALL,
		}
	},
	methods: {
		btnAddPrioritySupport(){
			// this is only for adding priority support to an exisiting active subscription
			this.$store.dispatch('cart/getNewCart').then(()=>{
				this.$router.push({
					name: 'PaymentSettingsPrioritySupport',
				}).catch(()=>{});
			});
		},//e:btnAddPrioritySupport
	},
	mounted() {
		if(this.$store.state.api.token === ''){
			// user is not logged in
			this.$router.push({
				name: 'LoginToOfficeHours'
			});

		} else {
			// user is logged in, keep moving
			AS_SyncData().then(()=>{
				// does user have priority support
				if(this.$store.state.customer.hasPrioritySupport){
					this.hasPrioritySupport = true;

					if(config.today.getDay() === ACTIVE_DAY_OF_WEEK){
						// day match - check time
						const todayWithTime = new Date();
						const currentHour = todayWithTime.getUTCHours();
						const currentMinute = todayWithTime.getUTCMinutes();

						// Convert start and end times to minutes for easier comparison
						const startMinutes = ACTIVE_TIME_START.hour * 60 + ACTIVE_TIME_START.minute;
						const endMinutes = ACTIVE_TIME_END.hour * 60 + ACTIVE_TIME_END.minute;
						const currentMinutes = currentHour * 60 + currentMinute;
						
						// console.log('currentMinutes');
						// console.log(currentMinutes);

						// should we start a timer to countdown an auto redirect
						if(currentMinutes >= (startMinutes - MINS_BEFORE_TO_START_TIMER)){
							// console.log('start the timer');

							this.isShowJoinButtonMessage = true;

							setInterval(()=>{
								let timerTodayWithTime = new Date();
								let timerCurrentHour = timerTodayWithTime.getUTCHours();
								let timerCurrentMinute = timerTodayWithTime.getUTCMinutes();

								const timerCurrentMinutes = timerCurrentHour * 60 + timerCurrentMinute;

								// console.log('startMinutes ' + startMinutes);
								// console.log('timerCurrentMinutes ' + timerCurrentMinutes);

								if(timerCurrentMinutes >= startMinutes){
									this.isJoinButtonShown = true;

									// also auto fire directing to the zoom call automatically
									// window.location = LINK_TO_ZOOM_CALL;
								}
							}, SECONDS_THE_TIMER_RUNS * 1000); //e:setInterval

						}//e:if 
						
						// Check if the current time is within the specified range
						if (currentMinutes >= startMinutes && currentMinutes <= endMinutes) {
							this.isDayCheck = true;

							// all the conditions are met, lets forward to the zoom room
							window.location = LINK_TO_ZOOM_CALL;
							// console.log('window.location to zoom call')
							// this.$store.commit('loaders/REMOVE_ID', 'App');

						} else {
							this.isDayCheck = false;
							this.$store.commit('loaders/REMOVE_ID', 'App');

						}//e:if

					} else {
						// not a day match
						this.isDayCheck = false;
						this.$store.commit('loaders/REMOVE_ID', 'App');

					}

				} else {
					this.hasPrioritySupport = false;
					this.$store.commit('loaders/REMOVE_ID', 'App');

				}//e:if.hasPrioritySupport

				this.hasLoaded = true;

			});//e:AS_SyncData
		}

	},
	components: {
		NavTabContent,
	}
}
</script>
